<template>
  <div>
    <div class="shadow_box rounded-lg p-6 relative flex flex-col">
      <p class="title"><strong>Pesquisa</strong></p>
      <form class="mt-1 w-full" @submit.prevent="reloadTable">
        <div class="flex flex-wrap mb-4 px-4">
          <multi-select-input v-model="filters.SupportMaterial.provider" :multiple="false" :options="providerOptions"
            class="lg:pr-6 w-full lg:w-1/4" label="Fornecedor" />
        </div>
        <div class="flex flex-shrink-0 flex-wrap items-center justify-start p-4 rounded-b-md gap-1">
          <button
            class="btn-purple px-6 py-2.5 text-white font-roboto font-medium text-xs leading-tight uppercase rounded shadow-md"
            type="submit">
            <font-awesome-icon icon="fa-magnifying-glass" class="text-white text-sm mr-0 lg:mr-2" />
            Pesquisar
          </button>
          <button
            class="btn flex items-center text-purple-100 font-roboto font-medium uppercase px-6 py-2.5 text-xs leading-tight border-2 border-purple-100"
            @click.prevent="clearSearch">
            <font-awesome-icon icon="fa-eraser" class="text-purple text-sm mr-0 lg:mr-2" />
            Limpar
          </button>
        </div>
      </form>
    </div>

    <Head title="Material de Apoio" />
    <div class="shadow_box rounded-lg p-6 mt-4">
      <h1 class="mb-6 text-2xl text-gray-777 font-roboto uppercase">Material de Apoio</h1>
      <data-table v-if="loadTable" v-model:columns="columns" route="support_materials/list" :query="getQuery"
        no-data-label="Nenhum material cadastrado" no-result-label="Nenhum material encontrado">
        <template #table.cell.content.provider_name="{ value }">
          <span v-tooltip.bottom="value" class="cursor-context-menu">
            {{ value && value.length > 80 ? value.substring(0, 80) + '...' : (value || '-') }}
          </span>
        </template>
        <template #table.cell.content.file_url="{ value, row }">
          <span v-if="!value" class="text-gray-500 text-sm">Sem arquivo</span>
          <a v-else :href="value" target="_blank"
            class="inline-flex items-center bg-purple-100 text-white rounded p-2 text-sm hover:bg-purple-200 transition">
            <font-awesome-icon icon="fa-file-pdf" class="mr-1" /> Visualizar PDF
          </a>
        </template>
        <template #table.cell.content.actions="{ row }">
          <div class="inline-flex gap-3">
            <span @click="openModalEdit(row)" class="bg-purple-200 text-white rounded p-2 cursor-pointer text-sm">
              <font-awesome-icon icon="fa-pencil" class="text-white mr-2" />Editar
            </span>
            <span @click="openModalConfirmDelete(row)"
              class="bg-red_delete text-white rounded p-2 cursor-pointer text-sm">
              <font-awesome-icon icon="fa-trash-can" class="text-white mr-2" />Excluir
            </span>
          </div>
        </template>
        <template #after.reload-button>
          <button class="flex items-end font-roboto font-medium btn-purple uppercase"
            @click.prevent="openModalEdit({})">
            <font-awesome-icon icon="fa-plus" class="text-white text-lg mr-0 lg:mr-2" />
            <span class="hidden lg:block">Adicionar Material</span>
          </button>
        </template>
      </data-table>
    </div>
    <modal-delete ref="modalDelete" @confirm="reloadTable" />
    <modal-edit ref="modalEdit" id="modal-material" title="Material" url="support_materials" :multipart="true"
      @submitForm="handleSubmit">
      <template #form="{ item }">
        <text-input v-model="item.title" :error="item.errors.title" class="lg:pr-6 w-full lg:w-1/2"
          label="Título do Material de Apoio" required="*" />

        <textarea-input v-model="item.description" :error="item.errors.description" class="lg:pr-6 w-full lg:w-3/4 mt-6"
          label="Descrição" placeholder="Descrição opcional do material" />

        <multi-select-input v-model="item.provider_ids" :multiple="true" :options="providerOptionsWithAll"
          appendTo="#modal-material" class="lg:pr-6 w-full lg:w-3/4 mt-6" label="Fornecedores"
          placeholder="Selecione fornecedores ou 'Todos'" :error="item.errors.provider_ids"
          @select="handleProviderSelection(item)" />

        <div class="w-full text-xs text-gray-500 mt-1 mb-3">
          <strong>💡 Dica:</strong> Selecione "Todos os fornecedores" para disponibilizar a todos, ou deixe vazio para
          não disponibilizar.
        </div>

        <file-input v-model="item.file" :error="item.errors.file" class="w-full lg:w-1/2 mt-6" label="Arquivo PDF"
          accept="application/pdf" />
      </template>
    </modal-edit>
  </div>
</template>
<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import DataTable from '@/Shared/DataTable.vue'
import ModalEdit from '@/Shared/ModalEdit.vue'
import ModalDelete from '@/Shared/ModalDelete.vue'
import SelectInput from '@/Shared/SelectInput.vue'
import MultiSelectInput from '@/Shared/MultiSelectInput.vue'
import TextInput from '@/Shared/TextInput.vue'
import TextareaInput from '@/Shared/TextareaInput.vue'
import FileInput from '@/Shared/FileInput.vue'
import Layout from '@/Shared/Layout'
import { useMemorizeFilters } from '@/Mixins/MemorizeFilters'

export default {
  components: {
    Head,
    Link,
    DataTable,
    ModalEdit,
    ModalDelete,
    SelectInput,
    MultiSelectInput,
    TextInput,
    TextareaInput,
    FileInput
  },
  props: { providerOptions: Array },
  layout: Layout,
  data() {
    return {
      loadTable: true,
      filters: { SupportMaterial: { provider: null } },
      columns: [
        {
          uniqid: 'title',
          field: 'title',
          label: 'TÍTULO',
          visible: true,
          sortable: true,
          sortOrder: 'asc',
          classes: 'px-4 py-3 border-b text-sm',
          headerClass: 'p-4 text-left',
        },
        {
          uniqid: 'provider_name',
          field: 'provider_name',
          label: 'FORNECEDOR',
          type: 'slot',
          visible: true,
          sortable: false,
          classes: 'px-4 py-3 border-b text-sm',
          headerClass: 'p-4 text-left',
        },
        {
          uniqid: 'file_url',
          field: 'file_url',
          label: 'MATERIAL',
          type: 'slot',
          visible: true,
          sortable: false,
          classes: 'px-4 py-3 border-b text-sm',
          headerClass: 'p-4 text-left',
        },
        {
          uniqid: 'actions',
          field: 'actions',
          label: 'AÇÕES',
          type: 'slot',
          visible: true,
          align: 'center',
          classes: 'py-3 border-b',
          headerClass: 'p-4',
        },
      ],
    }
  },
  computed: {
    providerOptionsWithAll() {
      return [
        { value: 'all', label: 'Todos os fornecedores' },
        ...this.providerOptions
      ]
    },
    getQuery() {
      const params = []
      if (this.filters.SupportMaterial.provider) {
        params.push(`search[provider]=${this.filters.SupportMaterial.provider}`)
      }
      return params.join('&')
    }
  },
  methods: {
    reloadTable() {
      this.loadTable = false
      setTimeout(() => (this.loadTable = true), 50)
    },
    clearSearch() {
      this.clearFilters()
      this.reloadTable()
    },
    openModalEdit(row) {
      row = row || {}
      row.errors = row.errors || {}
      row.title = row.title || ''
      row.description = row.description || ''
      row.provider_ids = row.provider_ids || []

      // Sempre inicializa file como null para não enviar dados do arquivo existente
      // O usuário só envia novo arquivo se selecionar um
      row.file = null

      this.$refs.modalEdit.openModalEdit(row)
    },
    openModalConfirmDelete(row) {
      this.$refs.modalDelete.openModalDelete(
        row,
        `/support_materials/${row.id}`,
        `Deseja realmente excluir o material "${row.title}"?`
      )
    },
    handleSubmit(item) {
      this.reloadTable()
    },
    handleProviderSelection(item) {
      // Se "Todos" foi selecionado, remove as outras opções
      if (item.provider_ids && item.provider_ids.includes('all')) {
        // Se já tinha "Todos" e adicionou outro, remove "Todos"
        if (item.provider_ids.length > 1) {
          // Se o último adicionado foi "Todos", mantém só ele
          const lastIndex = item.provider_ids.lastIndexOf('all')
          if (lastIndex === item.provider_ids.length - 1) {
            item.provider_ids = ['all']
          } else {
            // Se adicionou outro depois de "Todos", remove "Todos"
            item.provider_ids = item.provider_ids.filter(id => id !== 'all')
          }
        }
      }
    },
  },

  setup() {
    const { filtersStore, setFiltersComponent, getFiltersComponent, clearFiltersComponent } = useMemorizeFilters()

    setFiltersComponent('SupportMaterial')

    const clearFilters = () => clearFiltersComponent('SupportMaterial')
    const getFilters = () => getFiltersComponent('SupportMaterial')

    return {
      getFilters,
      clearFilters,
      filters: filtersStore.filters
    }
  }
}
</script>
